import { useMarkingContext } from '../MarkingContext/MarkingContext';
import SelectYearLevel from '../../SelectCustom/SelectYearLevel';
import SelectLearningAreas from '../../SelectCustom/SelectLearningAreas';
import { FormControlLabel, Skeleton, Switch, Typography } from '@mui/material';
import ButtonClasses from '../FilterClasses/ButtonClasses';

const Filters = () => {
  const { isLoading, selector, filter, onFilter, currentPeriodicalReport, loading, loadingSave } =
    useMarkingContext();

  if (isLoading) {
    return <Skeleton width={120} className='h-10' variant='rectagular' />;
  }
  
  if (!currentPeriodicalReport?.isGeneratedMarking) {
    return <></>;
  }

  return (
    <div className='flex flex-nowrap gap-4 items-center'>
      <div className='min-w-100-px max-w-150-px'>
        <FormControlLabel
          id='periodical-report-filter-empty-rows'
          control={
            <Switch
              onChange={(e) => onFilter({ isEmpty: e.target.checked })}
              name='isEmpty'
              color='primary'
            />
          }
          label={
            <Typography variant='inherit' component={'p'} className='text-uppercase text-bold text-small'>
              Empty rows
            </Typography>
          }
        />
      </div>
      {selector === 'filter-by-classes' ? (
        <ButtonClasses />
      ) : (
        <>
          <div className='min-w-100px max-w-150px'>
            <SelectLearningAreas
              onChange={(e) => onFilter({ learningArea: e.target.value })}
              value={filter.learningArea}
              disabled={loading || loadingSave}
            />
          </div>
          <div className='min-w-100px max-w-150px'>
            <SelectYearLevel
              value={filter.yearLevel}
              onChange={(e) => onFilter({ yearLevel: e.target.value })}
              disabled={loading || loadingSave}
            />
          </div>
        </>
      )}
    </div>
  );
};

export default Filters;
